__turbopack_context__.v({
  "Body": "Body-module__PnxMdG__Body",
  "FilterItems": "Body-module__PnxMdG__FilterItems",
  "accordion": "Body-module__PnxMdG__accordion",
  "accordionItem": "Body-module__PnxMdG__accordionItem",
  "button": "Body-module__PnxMdG__button",
  "chevron": "Body-module__PnxMdG__chevron",
  "clearButton": "Body-module__PnxMdG__clearButton",
  "closeFilter": "Body-module__PnxMdG__closeFilter",
  "container": "Body-module__PnxMdG__container",
  "count": "Body-module__PnxMdG__count",
  "description": "Body-module__PnxMdG__description",
  "filter": "Body-module__PnxMdG__filter",
  "filterButton": "Body-module__PnxMdG__filterButton",
  "filterItem": "Body-module__PnxMdG__filterItem",
  "header": "Body-module__PnxMdG__header",
  "icon": "Body-module__PnxMdG__icon",
  "input": "Body-module__PnxMdG__input",
  "item": "Body-module__PnxMdG__item",
  "items": "Body-module__PnxMdG__items",
  "left": "Body-module__PnxMdG__left",
  "moreText": "Body-module__PnxMdG__moreText",
  "name": "Body-module__PnxMdG__name",
  "open": "Body-module__PnxMdG__open",
  "overlay": "Body-module__PnxMdG__overlay",
  "range": "Body-module__PnxMdG__range",
  "right": "Body-module__PnxMdG__right",
  "row": "Body-module__PnxMdG__row",
  "sort": "Body-module__PnxMdG__sort",
  "text": "Body-module__PnxMdG__text",
  "title": "Body-module__PnxMdG__title",
  "tree": "Body-module__PnxMdG__tree",
  "value": "Body-module__PnxMdG__value",
});
